import React from "react"
import dayjs from "dayjs"

interface EventBadgeProps {
  dateTime: string
  endDate?: string
}

const EventBadge: React.FC<EventBadgeProps> = ({ dateTime, endDate }) => {
  const startDate = dayjs(dateTime)
  const endDateObj = endDate ? dayjs(endDate) : null

  const monthAbbr = startDate.format("MMM")
  const startDay = startDate.format("D")
  const endDay = endDateObj ? endDateObj.format("D") : null

  // Update the time formatting
  const time = startDate.minute() === 0 ? startDate.format("hA") : startDate.format("h:mmA")

  const getOrdinal = (n: number) => {
    const s = ["th", "st", "nd", "rd"]
    const v = n % 100
    return s[(v - 20) % 10] || s[v] || s[0]
  }

  return (
    <div className="event-badge">
      <span className="month">{monthAbbr}</span>
      <span className="day">
        <span className="day-number">{startDay}</span>
        <span className="day-ordinal">{getOrdinal(parseInt(startDay))}</span>
        {endDay && endDay !== startDay && (
          <>
            {" - "}
            <span className="day-number">{endDay}</span>
            <span className="day-ordinal">{getOrdinal(parseInt(endDay))}</span>
          </>
        )}
      </span>
      <span className="time">{time}</span>
    </div>
  )
}

export default EventBadge
